
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/menu",
      function () {
        return require("private-next-pages/[lang]/menu/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/menu"])
      });
    }
  